import styled from '@emotion/styled';
import { tokens } from '@sunrun/experience-ui-components';

type CountBadgeProps = {
  badgeCount: number;
};

const CountBadge = ({ badgeCount }: CountBadgeProps) => {
  if (badgeCount <= 0) {
    return null;
  }

  return <Badge aria-hidden="true">{badgeCount}</Badge>;
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  box-sizing: border-box;
  /* Roobert's digits render about 1px below the flex-centered line box. */
  padding-bottom: 2px;
  border-radius: 50%;
  background: ${tokens.NOTIFICATION_BADGE};
  color: ${tokens.WHITE};
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
`;

export { CountBadge };
